var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.28571,
    fill: "#202635"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.015 10.0707H7.71484V17.1422H10.015V10.0707Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2803 10.1537C16.2558 10.1459 16.2327 10.1376 16.207 10.1305C16.1761 10.1234 16.1453 10.1177 16.1138 10.1125C15.9916 10.0881 15.8579 10.0707 15.7011 10.0707C14.3601 10.0707 13.5096 11.0459 13.2293 11.4227V10.0707H10.9291V17.1422H13.2293V13.285C13.2293 13.285 14.9676 10.864 15.7011 12.6422C15.7011 14.2294 15.7011 17.1422 15.7011 17.1422H18.0006V12.3702C18.0006 11.3018 17.2683 10.4114 16.2803 10.1537Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83984 9.10645C9.46116 9.10645 9.96484 8.60277 9.96484 7.98145C9.96484 7.36013 9.46116 6.85645 8.83984 6.85645C8.21852 6.85645 7.71484 7.36013 7.71484 7.98145C7.71484 8.60277 8.21852 9.10645 8.83984 9.10645Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.eb34bac5.svg";
export { ForwardRef as ReactComponent };